import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { StorageService, UserService } from '@services/services.module';
import { CookieService } from '@services/cookie/cookie.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  logOutSession: any;

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private _user: UserService,
    private cookie_service: CookieService,
    private storage: StorageService
  ) {
    this.cookie_service.deleteAll();
    // this._user.logOut();
   }

  ngOnInit() {
    // For security we delete all data in session storage
    this.storage.removeAll();
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
    });

    // observable para controlar la expulcion por inactividad del usuario
    this._user.sessionExpired$.subscribe(data => {
        this.logOutSession = data;
    });

  }

  doLogin() {
    this._user.logIn();
  }
}
